import { paperStyles } from '@festina-life/ui/libs'
import { Icon, Typography } from '@festina-life/ui/structure'
import cx from 'classnames'

import { useMetaModelContext } from '../../context/metaModelContext'

type Props = {
  block: string
  className?: string
  shouldHideRootBlock?: boolean
  shouldShowIcon?: boolean
  isSecondaryBackground?: boolean
}

export const BlockIndicator = ({
  block,
  className,
  shouldHideRootBlock,
  isSecondaryBackground,
  shouldShowIcon = true,
}: Props) => {
  const { blockTopology } = useMetaModelContext()
  const isRootBlock = block === blockTopology.name

  return isRootBlock && shouldHideRootBlock ? null : (
    <Typography
      size="sm"
      intensity="secondary"
      weight="semibold"
      className={cx(
        'm-0 rounded-md px-1! shadow-md flex items-center gap-x-1',
        paperStyles({ isFaded: !isSecondaryBackground }),
        className,
      )}
    >
      {shouldShowIcon && <Icon name="Cube" />}
      {block}
    </Typography>
  )
}
